//AEATEAM-724: this files content should be FootnotesHelper_GLOBALELEM when the globalelem footnote solution is to go live
import * as footnoteNew from './FootnotesHelper_GLOBALELEM';
import * as footnoteOld from './FootnotesHelper_OWC';

const selectedModule = window.owcfe.isProduction ? footnoteOld : footnoteNew;

export const {
  addFootnotesToStore,
  isFootnoteLoaded,
  getLocalFootnotes,
  loadFootnoteComponents,
  setReference,
  setModuleId,
  mountFootnotes,
} = selectedModule as any;
